import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './settings.css';

const HelpSupportScreen = () => {
  const { t } = useTranslation(['translation', 'faq']);
  const FAQ_ITEMS = t('items', { ns: 'faq', returnObjects: true }) || [];
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="settings-screen">
      <header className="settings-header">
        <button onClick={() => navigate('/profile')} className="back-button">
          &larr;
        </button>
        <h1>{t('help.title')}</h1>
      </header>
      <main className="settings-content" style={{ textAlign: 'left' }}>

        {/* Section 1: FAQ */}
        <div className="settings-pref-card help-faq-card">
          {FAQ_ITEMS.map((item, index) => (
            <div
              key={index}
              className={`faq-item${index === FAQ_ITEMS.length - 1 ? ' faq-item--last' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => handleToggle(index)}
                aria-expanded={openIndex === index}
                type="button"
              >
                <span>{item.q}</span>
                <span className="faq-arrow" aria-hidden="true">
                  {openIndex === index ? '\u25B2' : '\u25BC'}
                </span>
              </button>
              <div className={`faq-answer${openIndex === index ? ' faq-answer--open' : ''}`}>
                <p className="faq-answer-text">{item.a}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Section 2: Contact Us */}
        <div className="settings-pref-card help-link-card">
          <a
            href="mailto:dev@lightandcover.org?subject=Lightway%20App%20Support"
            className="help-menu-item"
          >
            <div>
              <div className="help-menu-label">{t('help.emailUs')}</div>
              <div className="help-menu-subtext">dev@lightandcover.org</div>
            </div>
            <span className="help-menu-arrow">{'>'}</span>
          </a>
        </div>

        {/* Section 3: Submit Feedback */}
        <div className="settings-pref-card help-link-card">
          <Link to="/my-feedback" className="help-menu-item">
            <div>
              <div className="help-menu-label">{t('help.submitFeedback')}</div>
              <div className="help-menu-subtext">{t('help.submitFeedbackDesc')}</div>
            </div>
            <span className="help-menu-arrow">{'>'}</span>
          </Link>
        </div>

        {/* Section 4: Legal */}
        <div className="settings-pref-card help-link-card">
          <Link to="/terms-of-service" className="help-menu-item">
            <span className="help-menu-label">{t('help.termsOfService')}</span>
            <span className="help-menu-arrow">{'>'}</span>
          </Link>
          <Link to="/privacy-policy" className="help-menu-item help-menu-item--last">
            <span className="help-menu-label">{t('help.privacyPolicy')}</span>
            <span className="help-menu-arrow">{'>'}</span>
          </Link>
        </div>

      </main>
    </div>
  );
};

export default HelpSupportScreen;
